const FILTER_TYPES = {
    text: 'text',
    date: 'date',
    datetime: 'datetime',
    numeric: 'numeric',
    enum: 'enum', // API spec enum or custom field type
    boolean: 'boolean',
    header: 'header',
    custom: 'custom', // for custom fields
    select: 'select',
    random: 'random',
};

export default FILTER_TYPES;
